export default [
  { title: 'Payment systems', routeName: 'payment-systems' },

  { title: 'Currencies and tokens', routeName: 'payment-systems-and-currencies' },

  { title: 'Networks', routeName: 'payment-systems-networks' },
];
